import {
	Box,
	Card,
	CardContent,
	CardHeader,
	Collapse,
	IconButton,
	Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ExpandMoreOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useState } from 'react'

import {
	BulletsSection,
	FoundingTextBoxSection,
	LaunchStateSection
} from '../Market/AdvancedSettings'

const useStyles = makeStyles((theme) => ({
	header: {
		textDecoration: 'none'
	},
	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest
		}),
		padding: 0
	},
	expandOpen: {
		transform: 'rotate(180deg)'
	},
	card: {
		maxWidth: '1245px',
		marginBottom: 16
	}
}))

const LaunchState = ({ selectedFacility, setCurrent }) => {
	const classes = useStyles()
	const [isExpanded, setIsExpanded] = useState(true)
	const launch = selectedFacility?.launch || {}
	const migrated = Boolean(selectedFacility?.launch)

	const updateLaunch = (key, value) => {
		setCurrent({
			...selectedFacility,
			launch: {
				...(selectedFacility.launch || {}),
				[key]: value
			}
		})
	}

	const marketOnStageTwo = launch.phase === 'pre_launch_with_memberships'
	const marketOnStagesTwoTreeFour = [
		'pre_launch_with_memberships',
		'post_launch_limited_services',
		'fully_open'
	].includes(launch.phase)
	const marketOnFinalStages = ['post_launch_limited_services', 'fully_open'].includes(launch.phase)

	return (
		<Card className={classes.card}>
			<CardHeader
				className={classes.header}
				title="Launch State"
				onClick={() => setIsExpanded(!isExpanded)}
				action={
					<IconButton
						className={clsx(classes.expand, {
							[classes.expandOpen]: isExpanded
						})}
						onClick={() => setIsExpanded(!isExpanded)}
						aria-expanded={isExpanded}
						aria-label="show more">
						<ExpandMoreOutlined style={{ fill: '#777679' }} />
					</IconButton>
				}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<CardContent>
					{!migrated ? (
						<Typography variant="body2" color="textSecondary">
							Launch settings have not been migrated for this facility yet. Run the
							market-to-facility migration before editing launch state.
						</Typography>
					) : (
						<Box style={!selectedFacility.active ? { opacity: 0.6, pointerEvents: 'none' } : undefined}>
							<LaunchStateSection
								selectedMarket={launch}
								updateMarket={updateLaunch}
								marketOnFinalStages={marketOnFinalStages}
							/>
							{!marketOnFinalStages && (
								<BulletsSection
									selectedMarket={launch}
									updateMarket={updateLaunch}
									marketOnStageTwo={marketOnStageTwo}
								/>
							)}
							{marketOnStagesTwoTreeFour && (
								<FoundingTextBoxSection
									selectedMarket={launch}
									updateMarket={updateLaunch}
								/>
							)}
						</Box>
					)}
				</CardContent>
			</Collapse>
		</Card>
	)
}

export default LaunchState
